var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/core-js/library/modules/_has.js
 ** module id = 52
 ** module chunks = 0
 **/